// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2QA2o","tab":"Tabs_tab__12nE6","tabActive":"Tabs_tabActive__chQry"};